import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

import { DatePickerDirective, IDatePickerConfig } from 'ng2-date-picker'
import { TranslateService } from '@ngx-translate/core'
import * as moment from 'moment'

const now = new Date();
const outputFormat = 'DD-MM-YYYY';

const deliveryPickerConfig: IDatePickerConfig = {
  dayBtnFormat: 'D',
  closeOnSelectDelay: 0,
  showNearMonthDays: false,
  monthFormat: 'MMMM, YYYY',
  drops: 'down',
  min: moment(new Date()), // make this dynamic
  firstDayOfWeek: "mo"

}

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DatePickerComponent),
    }
  ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor, OnChanges {
  datePickerConfig: IDatePickerConfig
  currentDate: moment.Moment
  open = false

  changeHandler = (date: string) => {}
  touchHandler = () => {}

  @Input() placeholder = ''
  @Input() format = outputFormat
  @Input() deliveryDateMode: string
  @Input() deliverydates: string[]

  @Output() valueChanged = new EventEmitter<boolean>()

  @ViewChild(DatePickerDirective) datePicker: DatePickerDirective

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit() {

    this.datePickerConfig = {
      ...deliveryPickerConfig,
      locale: this.translate.currentLang,
      min: this.minDate,
      isDayDisabledCallback: (date: moment.Moment) => {
        // date.day() === 0 || date.day() === 6 || date.isBefore(now) || date.isBefore(this.getMinimalDate())
        if (this.availableDeliveryDates.length > 0) {
          const dateFound = this.availableDeliveryDates.find(availableDate => availableDate.isSame(date, 'day'))
          return !dateFound
        } else {
          return date.day() === 0 || date.day() === 6 || date.isBefore(now) || date.isBefore(this.minDate)
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.deliverydates && changes.deliverydates.currentValue && changes.deliverydates.currentValue.length > 0) {
      this.datePickerConfig = {
        ...this.datePickerConfig
      }
    }
  }

  get current(): string {
    if(this.currentDate && this.currentDate.isValid())
      return this.currentDate.format('L')
    return this.placeholder
  }

  // Control Value Accessor Interface

  get minDate():moment.Moment {
    if (this.availableDeliveryDates.length > 0) {
      return moment.min(this.availableDeliveryDates)
    }

    return moment(new Date()).add(1, 'days')
  }

  public get availableDeliveryDates(): moment.Moment[] {
    if (this.deliverydates && this.deliverydates.length > 0) {
      return this.deliverydates.map(deliverydate => moment(deliverydate, 'YYYY-MM-DD'))
    }
    return []
  }


  writeValue(date: string) {
    this.currentDate = moment(date, this.format)
  }

  registerOnChange(cb: (date: string) => void) {
    this.changeHandler = cb
  }

  registerOnTouched(cb: () => void) {
    this.touchHandler = cb
  }

  // End Interface

  changedValue(date: moment.Moment) {
    if(date) {
      this.changeHandler(date.format(this.format))
      this.valueChanged.emit(true)
   }
  }

  openedPicker() {
   this.touchHandler()
  }

  closedPicker() {
    this.open = false
  }

  togglePicker() {
    if(this.open ) {
      this.datePicker.api.close()
      this.open = false
    } else {
      this.datePicker.api.open()
      this.open = true
    }
  }

}
